import {useEffect, useState} from 'react';

export default function useScrollHeader(containerRef, pathname, isAuthenticated = false) {
  const [hidden, setHidden] = useState(false);
  const [height, setHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 992);
  // Public pages animate at every size; authenticated desktop headers stay fixed.
  const enabled = !isAuthenticated || isMobile;
  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);
  useEffect(() => {
    setHidden(false);
    const header = containerRef.current?.querySelector('header');
    const measure = () => setHeight(header?.getBoundingClientRect().height || 0);
    measure();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    if (header) observer?.observe(header);
    let lastY = Math.max(0, window.scrollY);
    let distance = 0;
    let frame;
    const update = () => {
      frame = null;
      const y = Math.max(0, window.scrollY);
      const delta = y - lastY;
      if (Math.sign(delta) !== Math.sign(distance)) distance = 0;
      distance += delta;
      if (y < 80) setHidden(false);
      else if (Math.abs(distance) >= 8) {
        setHidden(distance > 0);
        distance = 0;
      }
      lastY = y;
    };
    const scroll = () => {if (!frame) frame = requestAnimationFrame(update);};
    if (enabled) window.addEventListener('scroll', scroll, {passive:true});
    window.addEventListener('resize', measure);
    return () => {
      observer?.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', scroll);
      window.removeEventListener('resize', measure);
    };
  }, [containerRef, pathname, enabled]);
  return {hidden: enabled && hidden, height, reveal: () => setHidden(false)};
}
